import http from 'services/http';

// AI-driven portal retrieval runs (OLIO-2605). The web app starts a run, hands its id
// to the browser extension, and the extension drives the AI turns — the recorded action
// sequence becomes a PortalScript. See services/portalExtension for the hand-off.

// One output the AI must capture. 'many' marks a list output (documents, the
// collected facilities) — the prompt tells the AI to use the *_all capture verbs so
// every value present lands, however many there are.
export interface PortalAiRunGoalOutput {
  name: string;
  cardinality: 'one' | 'many';
  description?: string;
}

export interface PortalAiRunGoal {
  outputs: PortalAiRunGoalOutput[];
  instructions?: string;
}

export interface CreatePortalAiRunInput {
  sourceSystem: string;
  goal: PortalAiRunGoal;
  availableParams: Record<string, string>;
}

export async function createPortalAiRun(input: CreatePortalAiRunInput) {
  return http.post<{ id: string; status: string }>('portal_ai_runs', input).then((res) => res.data);
}
